import microsoft from './icons/brand/microsoft.svg?raw';

// Logo bên thứ ba giữ đúng màu gốc của họ, nên nằm trong file SVG chứ không đi qua token.
const SVG = { microsoft } as const;

export function BrandIcon({ name, size = 18 }: { name: keyof typeof SVG; size?: number }) {
  return (
    <span
      aria-hidden="true"
      style={{ width: size, height: size, display: 'inline-flex', flexShrink: 0 }}
      dangerouslySetInnerHTML={{ __html: SVG[name] }}
    />
  );
}
